export default "__VITE_ASSET___hRmUeME__"